import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, getResetByTag, utilityStyles } from './../../styles';
var defaultStyles = /*#__PURE__*/css("background:", colors.coolGray_200, ";max-width:100%;width:", rem(350), ";tr{&:hover,&:focus{background:", colors.transparent, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));

/** Export to use as selector in other component's styles. */
var resetStyles = getResetByTag('div');
var StyledCalendar = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "ekdzci30"
} : {
  target: "ekdzci30",
  label: "StyledCalendar"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledCalendar;